import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateConverterPipe } from './date-converter.pipe';
import { SlaDatePipe } from './date.pipe';
import { FilterOptionsPipe } from './filter-options.pipe';
import { FindInArrayPipe } from './find-in-array.pipe';
import { IsActiveRoutePipe } from './is-active-route.pipe';
import { PlaceholderPipe } from './placeholder.pipe';
import { GenericInputLabelPipe } from './generic-input-label.pipe';
import { FilterPipe } from './filter.pipe';

export *  from './find-in-array.pipe';
export *  from './is-active-route.pipe';
export *  from './date.pipe';
export *  from './date-converter.pipe';
export *  from './placeholder.pipe';
export *  from './filter-options.pipe';
export * from './filter.pipe';
export * from './generic-input-label.pipe';

@NgModule({
    declarations: [
        FindInArrayPipe,
        IsActiveRoutePipe,
        DateConverterPipe,
        SlaDatePipe,
        PlaceholderPipe,
        FilterOptionsPipe,
        GenericInputLabelPipe,
        FilterPipe,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        FindInArrayPipe,
        IsActiveRoutePipe,
        DateConverterPipe,
        SlaDatePipe,
        PlaceholderPipe,
        FilterOptionsPipe,
        GenericInputLabelPipe,
        FilterPipe,
    ],
})
export class PipesModule {
}
